__turbopack_context__.v({
  "content": "app-shell-module-scss-module__ilaWZq__content",
  "inner": "app-shell-module-scss-module__ilaWZq__inner",
  "main": "app-shell-module-scss-module__ilaWZq__main",
  "narrow": "app-shell-module-scss-module__ilaWZq__narrow",
  "root": "app-shell-module-scss-module__ilaWZq__root",
  "sidebar": "app-shell-module-scss-module__ilaWZq__sidebar",
  "two_columns": "app-shell-module-scss-module__ilaWZq__two_columns",
});
